module.exports = {"id":"199761","name":"Marcin Kamiński","rating":"73","photo":"./data/images/photos/0/199761.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcinKaminski0.json
// module id = 2726
// module chunks = 0